export default __webpack_public_path__ + "static/media/Punto_12_Cantina_Palio_Marinaro_SPA_Def.415b42e5.aac";